import { URL_API } from "@/config";
import { tokenDecrypted } from "@/utils/decryptToken";
import { url } from "@/utils/urlParam";
import axios from "axios";

const urlApi = "payrun-process";

export async function getPayrunProcess({ companyId, periodicId }) {
  try {
    const params = new URLSearchParams(url.search);
    params.append("company_id", companyId);
    params.append("periodic_id", periodicId);
    const { data } = await axios.get(
      `${URL_API}/${urlApi}?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenDecrypted()}`,
        },
      }
    );
    return { success: true, message: "", data: data.data, code: 200 };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}

export async function processPayrunProcess(payload) {
  try {
    const { data } = await axios.post(`${URL_API}/${urlApi}`, payload, {
      headers: {
        Authorization: `Bearer ${tokenDecrypted()}`,
      },
    });

    if (payload.typeFile === "csv") {
      const blob = new Blob([data.data], { type: "application/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", data.fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } else {
      const link = document.createElement("a");
      link.href = `${process.env.URL}/${data.data.path}`;
      link.setAttribute("download", `${data.data.fileName}`);
      link.setAttribute("target", "_blank");
      link.click();
    }

    return {
      success: true,
      message: data.messsage,
      data: data.data,
      code: 200,
    };
  } catch (error) {
    return {
      success: false,
      code: error.response.status,
      message: error.response.statusText,
      data: [],
    };
  }
}
